import instance from './common';

export const getPersistence = (params, http = instance, options = {}) =>
  http.get('/persistence', params, options);

export const deletePersistence = (key, http = instance, options = {}) =>
  http.delete(`/persistence${key}`, options);

export const putPersistence = (payload, http = instance) => http.put('/persistence', payload);

export const persistenceStats = (payload, http = instance) =>
  http.post('/persistence/stats', payload);

export const persistenceSearch = (payload, http = instance) =>
  http.post('/persistence/search', payload);

export const persistenceClear = (payload, http = instance) =>
  http.post('/persistence/clear', payload);
